import React from 'react'
import ShareMedicalRecord from './components/shareMedicalRecord';
import doctor from '../../assets/images/undraw_medical_care_movn.svg'
import { Link } from 'react-router-dom';

function Dashboard() {

  return (

    <section className="hero is-fullheight-with-navbar">
      <div style={{ padding: '2rem 2rem' }}>
        <div className="container">

          <h1 className="title is-1 is-light is-semibold is-spaced main-title is-justify-content-center is-flex "> Dashboard</h1>
          <h1 className=" is-justify-content-end is-flex mb-2"> <ShareMedicalRecord /></h1>

          <div className="columns is-vcentered">
            <div className="column is-5">
              <div className='is-flex is-justify-content-center'>
                <div className='box main-box'>
                  <Link to="/channeling">
                    <div className='box mb-5 title is-3 has-text-centered' style={{ color: '#FFFFFF', backgroundColor: '#54F19D' }}>
                      <div className='mt-5 mb-5'>
                        <i className="fa fa-user-md" aria-hidden="true"></i>
                        <span className='ml-2'>
                          Channelings
                        </span>
                      </div>
                    </div>
                  </Link>
                  <Link to="/medicines">
                    <div className='box mb-5 title is-3 has-text-centered' style={{ color: '#FFFFFF', backgroundColor: '#6892FF' }}>
                      <div className='mt-5 mb-5'>
                        <i className="fa-solid fa-capsules"></i>
                        <span className='ml-2'>
                          Medicines
                        </span>
                      </div>
                    </div>
                  </Link>
                  <Link to="/articles">
                    <div className='box title is-3 has-text-centered' style={{ color: '#FFFFFF', backgroundColor: '#FC7A71' }}>
                      <div className='mt-5 mb-5'>
                        <i className="mr-3 fa-solid fa-gear"></i>
                        <span className='ml-2'>
                          Articles
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="column is-7">
              <div className='is-flex is-justify-content-center'>
                <img src={doctor} alt="svg" style={{ width: '80%' }} />
              </div>
            </div>
          </div>
        </div>
      </div >
    </section >


  )
}

export default Dashboard;
